const { mainTaxFields, allTaxFields } = require('./taxFieldsConfig');

// This function is stored in a separate file to avoid circular
// dependencies with Data Server
const getTaxonomyIds = (
  content,
  options = { includeParents: false, useAllTaxonomies: false }
) => {
  const tags = new Set();
  if (content.primaryTaxonomy?.entity?.tid) {
    tags.add(content.primaryTaxonomy.entity.tid);
    if (options.includeParents) {
      content.primaryTaxonomy.entity.parents?.forEach(parentTerm => {
        tags.add(parentTerm.tid);
      });
    }
  }
  const taxFields = options.useAllTaxonomies ? allTaxFields : mainTaxFields;
  taxFields.forEach(taxonomyName => {
    content[taxonomyName]?.forEach(taxonomyEntity => {
      if (taxonomyEntity.entity?.tid) {
        tags.add(taxonomyEntity.entity.tid);
        if (options.includeParents) {
          taxonomyEntity.entity.parents?.forEach(parentTerm => {
            tags.add(parentTerm.tid);
          });
        }
      }
    });
  });
  return tags;
};

module.exports = {
  getTaxonomyIds
};
